import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink, useLocation } from "react-router-dom";

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, " ");

const BreadcrumbsNav: React.FC = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 2 }}
        >
            <Link component={RouterLink} to="/" sx={{ display: "flex", alignItems: "center" }}>
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Home
            </Link>

            {pathnames.map((value, index) => {
                const isLast = index === pathnames.length - 1;
                const to = "/" + pathnames.slice(0, index + 1).join("/");

                return isLast ? (
                    <Typography key={to} color="text.primary">
                        {capitalize(value)}
                    </Typography>
                ) : (
                    <Link component={RouterLink} to={to} key={to}>
                        {capitalize(value)}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default BreadcrumbsNav;
